import React from 'react';
import Input from '../ShareholderDetails/Input';
import { TInfoltd } from '../../../types';

type TProps = {
  step1: TInfoltd;
};
const NamesOfBusiness = ({ step1 }: TProps) => {
  return (
    <div className='my-5'>
      <div className='text-[13px] font-[600] text-[#028789] mb-4'>Organization Names</div>

      <div className='sl:flex justify-between gap-[4%]'>
        <Input
          label={'Organization name 1'}
          value={step1.firstbusinessName}
          style='sl:w-[50%]'
          readonly
        />

        <Input
          label={'Organization name 2'}
          value={step1.secondbusinessName}
          style='sl:w-[50%]'
          readonly
        />
      </div>
      <div className='sl:flex justify-between gap-[4%]'>
        <Input
          label={'Organization name 3'}
          value={step1.threebusinessName}
          style='sl:w-[50%]'
          readonly
        />
        <Input
          label={'Organization name 4'}
          value={step1.fourthbusinessName}
          style='sl:w-[50%]'
          readonly
        />
      </div>
    </div>
  );
};

export default NamesOfBusiness;
